// ----------------------------------------------------------------------
// <copyright file="Izenda.RunCopyPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {
  "use strict";
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var classnames = require('classnames');
  var Popup = require('share/components/controls/CommonPopup/Izenda.Popup');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');  
  var EventsUtils = require('EventUtils');

  var RunCopyPopup = React.createClass({
    propTypes: {
      tree: React.PropTypes.object.isRequired,
      treeComponent: React.PropTypes.func.isRequired,
      title: React.PropTypes.string.isRequired,
      informationMessage: React.PropTypes.string.isRequired,
      confirmationMessage: React.PropTypes.string.isRequired      
    },

    render: function () {
      var props = this.props;
      var localization = props.localization;

      return (
        <Popup visible type='none' onClosing={this.onClosing} autoClose={false}>
          <Popup.Header title={props.title} />
          <Popup.Body>
            <div className='run-copy-info'>
              <GridLayout>
                <GridLayout.Row>
                  <div className='confirmation-info'>
                    <p>{props.informationMessage}</p>
                    <p>{props.confirmationMessage}</p>
                  </div>
                </GridLayout.Row>

              </GridLayout>
            </div>

            <GridLayout>
              <GridLayout.Row className='izenda-runCopyTree u_borderAll'>
                {this.renderTree()}
              </GridLayout.Row>
            </GridLayout>

          </Popup.Body>
          <Popup.Footer>
            <Popup.ConfirmationButton type='accept'>{localization.getText('COMMON_LABEL_OK')}</Popup.ConfirmationButton>
            <Popup.ConfirmationButton type='cancel'>{localization.getText('COMMON_LABEL_CANCEL')}</Popup.ConfirmationButton>
          </Popup.Footer>
        </Popup>
      );
    },

    renderTree: function () {
      var props = this.props;
      
      return (<props.treeComponent
        store={props.store}
        tree={props.tree}
        leafKey={props.leafKey}
        showCheckbox={true} />);
    },

    /**
     * onClosing popup
     */
    onClosing: function (closeCallback, type) {
      var props = this.props;

      if (type === 'accept') {
        return props.onAccept();
      } else if (type === 'cancel') {
        return props.onReject();
      }
    }
  });

  module.exports = connect()(RunCopyPopup);
} ());



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/RunCopy/Izenda.RunCopyPopup.jsx